import { axisAlignedBounds } from "./canvasGroupTransform";

export const LAYER_ALIGN = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
  TOP: "top",
  MIDDLE: "middle",
  BOTTOM: "bottom",
};

export const alignSelectedBoxes = ({ boxes = [], align }) => {
  if (boxes.length < 2) return boxes;
  const bounds = axisAlignedBounds(boxes);
  if (!bounds) return boxes;

  switch (align) {
    case LAYER_ALIGN.LEFT:
      return boxes.map((box) => ({ ...box, x: bounds.x }));
    case LAYER_ALIGN.CENTER:
      return boxes.map((box) => ({
        ...box,
        x: bounds.x + (bounds.width - box.width) / 2,
      }));
    case LAYER_ALIGN.RIGHT:
      return boxes.map((box) => ({
        ...box,
        x: bounds.x + bounds.width - box.width,
      }));
    case LAYER_ALIGN.TOP:
      return boxes.map((box) => ({ ...box, y: bounds.y }));
    case LAYER_ALIGN.MIDDLE:
      return boxes.map((box) => ({
        ...box,
        y: bounds.y + (bounds.height - box.height) / 2,
      }));
    case LAYER_ALIGN.BOTTOM:
      return boxes.map((box) => ({
        ...box,
        y: bounds.y + bounds.height - box.height,
      }));
    default: {
      const exhaustive = align;
      throw new Error(`Unhandled layer align: ${exhaustive}`);
    }
  }
};
